import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { useErrorStore } from './error-store';
import { fetchGdprTexts } from '../services/application';
import * as logger from '../utils/logger';

export const useGdprTextsStore = defineStore('gdpr-texts', {
    state: () => ({
        generalPolicy: {
            legalTextExternalId: null,
            body: '',
            url: null,
        },
        generalPolicyChecked: false,
        companyPolicy: {
            legalTextExternalId: null,
            body: '',
            url: null,
        },
        companyPolicyChecked: false,
        companyConsent: {
            legalTextExternalId: null,
            body: '',
            url: null,
            mandatory: '0', // '0' => not mandatory, '1' => mandatory
        },
        companyConsentChecked: false,
    }),
    getters: {
        fetched: state => state.generalPolicy.legalTextExternalId !== null,
        generalPolicyBody: state => state.generalPolicy.body,
        companyPolicyBody: state => state.companyPolicy?.body,
        companyConsentBody: state => state.companyConsent?.body,
        generalPolicyUrl: state => state.generalPolicy.url,
        companyPolicyUrl: state => state.companyPolicy?.url,
        companyConsentUrl: state => state.companyConsent?.url,
        companyConsentMandatory: state => state.companyConsent?.mandatory === '1',
    },
    actions: {
        // Reset in own action if we need to add steps at a later point
        reset() {
            this.$reset();
        },
        async getTexts(atsUserUuid, encryptedPayload) {
            const errors = useErrorStore();
            try {
                this.reset();
                const response = await fetchGdprTexts(atsUserUuid, encryptedPayload);
                this.setTexts(response.data);
            } catch (exception) {
                logger.warning({
                    exception,
                    message: 'Fetching gdpr texts failed.',
                });
                errors.general = true;
            }
        },
        setTexts(gdprTexts) {
            this.generalPolicy.legalTextExternalId = gdprTexts.generalPolicy.legalTextExternalId;
            this.generalPolicy.body = gdprTexts.generalPolicy.body;
            this.generalPolicy.url = gdprTexts.generalPolicy.url;

            if (gdprTexts.companyPolicy) {
                // eslint-disable-next-line max-len, vue/max-len
                this.companyPolicy.legalTextExternalId = gdprTexts.companyPolicy.legalTextExternalId;
                this.companyPolicy.body = gdprTexts.companyPolicy.body;
                this.companyPolicy.url = gdprTexts.companyPolicy.url;
            } else {
                this.companyPolicy = null;
            }

            if (gdprTexts.companyConsent) {
                // eslint-disable-next-line max-len, vue/max-len
                this.companyConsent.legalTextExternalId = gdprTexts.companyConsent.legalTextExternalId;
                this.companyConsent.body = gdprTexts.companyConsent.body;
                this.companyConsent.url = gdprTexts.companyConsent.url;
                this.companyConsent.mandatory = gdprTexts.companyConsent.mandatory;
            } else {
                this.companyConsent = null;
            }
        },
    },
    persist: {
        storage: sessionStorage,
        // DO NOT persist consent ("XyzChecked") paths.
        paths: ['fetched', 'generalPolicy', 'companyPolicy', 'companyConsent'],
    },
});
